import React from 'react';
import { Route } from 'react-router-dom';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';

//Wraps a route in an error boundary so that even if the page encounters an error, other routes remain accessible
export default (props) => (
    <ErrorBoundary>
        <Route {...props} />
    </ErrorBoundary>
)